// src/components/PaymentSetting/paymentSetting.js
import React, { useState } from 'react';
import './paymentSetting.css';
import { getFunctions, httpsCallable } from 'firebase/functions';

const PaymentSetting = () => {
  const [isLoading, setIsLoading] = useState(false);
  const functions = getFunctions();
  const manageBillingCallable = httpsCallable(functions, 'manageBilling');

  const handleManageClick = async () => {
    setIsLoading(true);
    try {
      const { data } = await manageBillingCallable();
      window.location.href = data.url;
    } catch (err) {
      // console.error('Failed to load billing portal URL:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="account-settings-container">
      <div className="settings-row">
        <div className="settings-label">Payment & Subscription</div>
        <div className="settings-field">
          {/* Switched from <a> to <button> for a11y */}
          <button
            type="button"
            className="ui-setting-button"
            onClick={handleManageClick}
            disabled={isLoading}
            aria-busy={isLoading}
          >
            {isLoading ? 'Loading…' : 'Manage'}
          </button>
        </div>
      </div>

      <div className="payment-help">
        <a
          href="https://intercom.help/bumpups/en/collections/7956855-billing"
          target="_blank"
          rel="noopener noreferrer"
        >
          Need help with billing?
        </a>
      </div>
            <div className="payment-help">
        <a
          href="https://bumpups.zapier.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact us
        </a>
      </div>
    </div>
  );
};

export default PaymentSetting;
